// @flow

// Skipping story doc and test coverage for this component since it is not possible to do it correctly
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
/* istanbul ignore file */

import * as React from 'react';
import type { Store } from 'redux';
import { Provider } from 'react-redux';
import { Router } from '@ta/common.routing';
import type { Action, State } from '@ta/common.state';
import { VirtualDOMPortalProvider } from '@ta/lithium.portals';
import Urql from '@ta/platform.urql';
import type { Client } from 'urql';
import Apollo from './Apollo';
import LithiumBridge from './LithiumBridge';

type Props = {|
  store: Store<State, Action>,
  apolloClient: any,
  urqlClient: Client,
  children: React.Node,
|};

const Root = ({ store, apolloClient, urqlClient, children }: Props) => (
  <Provider store={store}>
    <LithiumBridge>
      <Apollo client={apolloClient}>
        <Urql client={urqlClient}>
          <Router>
            <VirtualDOMPortalProvider>{children}</VirtualDOMPortalProvider>
          </Router>
        </Urql>
      </Apollo>
    </LithiumBridge>
  </Provider>
);

export default Root;
